import React, { Component } from 'react';
import { connect } from 'react-redux';
import intl from 'react-intl-universal';
import LanguageIcon from '@material-ui/icons/Language';

export class LanguageContainer extends Component {
  state = {
    open: false,
  };
  render() {
    return (
      <div className={`language-dropdown ${this.state.open ? 'active' : ''}`}>
        <div className="ld-container">
          <LanguageIcon className="language-icon" onClick={() => this.setState({ open: !this.state.open })} />
          <span className="actual-language">En</span>
          {this.state.open ? (
            <div className="menu">
              <div className="flag en">{intl.get('languages.English')}</div>
              <div className="flag es">{intl.get('languages.Spanish')}</div>
              <div className="flag fr">{intl.get('languages.French')}</div>
              <div className="flag ge">{intl.get('languages.German')}</div>
              <div className="flag jp">{intl.get('languages.Japanese')}</div>
              <div className="flag zh">{intl.get('languages.Chinese')}</div>
              <div className="flag pl">{intl.get('languages.Polish')}</div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LanguageContainer);
